module.exports = __webpack_public_path__ + "static/rospa_logo.d6fa9904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/rospa_logo.png
// module id = 3633
// module chunks = 114276838955818